export default "__VITE_ASSET__BZ7O1II5__"